<template>
  <a-modal :title="'请输入【 ' + langForName + ' 】字段的多语言内容'"
           :maskClosable='false'
           :visible='langDialogVisible'
           @ok='handleLangOk'
           @cancel='handleLangCancel'>
    <a-form :form='langForm'>
      <a-form-item v-for='(k, index) in langList'
                   :key='k.languageCode'
                   :index='index'
                   v-bind='formItemLayout'
                   :label='k.languageName'
                   :required='false'>
        <a-input v-decorator="[
            `${langForName}[${k.languageCode}]`,
            langForRequire
              ? {
                  validateTrigger: ['change', 'blur'],
                  initialValue: initialValues ? initialValues[index] : '',
                  rules: [
                    {
                      required: true,
                      whitespace: true,
                      message: '该项为必填',
                    },
                  ],
                }
              : { initialValue: initialValues ? initialValues[index] : '' },
          ]"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
export default {
  name: 'mtcLangModule',
  //props: ['langForName', 'langForName'],
  props: {
    tableName: {
      type: String,
      default: ''
    }
  },
  data(){
    return {
      rows: [],
      langForm: {}, // 弹框表单，存放数据
      initialValues: [], // 初始化显示数据
      langForRequire: false, // 弹框是否必填
      langDialogVisible: false,
      langForName: '', // 多语言字段
      langList: [], // 语言列表
      formItemLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 4 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 20 }
        }
      }
    }
  },
  mounted(){
    this.$bus.$off('mtcLangDialog')
    this.$bus.$on('mtcLangDialog', res => {
      // 触发多语言弹框显示
      // console.log('%c [ res ]', 'font-size:13px; background:pink; color:#bf2c9f;', res)
      this.showLangDialog(res)
    })
  },
  methods: {
    // subLangItems
    showLangDialog( res ){
      this.langForm = this.$form.createForm(this, { name: 'dynamic_form_item' })
      this.langForm.getFieldDecorator('keys', { initialValue: [], preserve: true })
      this.langList = JSON.parse(this.$ls.get('languageList'))
      let initialValue = res.initialValue || []
      let initialValues = []
      this.langList.map(( item ) => {
        initialValue.map(( sItem ) => {
          if (item.languageCode == sItem.langType) {
            // initialValues.push(sItem[res.field])
            initialValues.push(sItem[ 'langText' ])
          }
        })
      })
      this.initialValues = initialValues
      this.langForName = res.field
      this.langForRequire = res.require
      this.langDialogVisible = true
    },
    handleLangOk(){
      this.langForm.validateFields(( err, values ) => {
        if (!err) {
          let formData = values[ this.langForName ]
          this.$bus.$emit('mtcLangOk', {
            filedName: this.langForName,
            formData: formData,
            subLangIndex: this.subLangIndex,
            rows: this.rows,
            tableName: this.tableName
          })
          this.langDialogVisible = false
        }
      })
    },
    handleLangCancel(){
      this.langForm.resetFields()
      this.langDialogVisible = false
      this.$destroy()
    }
  },
  beforeDestroy(){
    this.$bus.$off('mtcLangDialog')
  }
}
</script>